var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal-checkbox',{attrs:{"title":_vm.resolveTitle(),"mode":"SLIDER"},model:{value:(_vm.day.paid),callback:function ($$v) {_vm.$set(_vm.day, "paid", $$v)},expression:"day.paid"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }